// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c99cc1e6]:export{primaryColor:#007a59;primaryLightColor:#1cb9fd;secondaryColor:#fdba12;accentColor:#96ff73;textColor:#333}.page-item[data-v-c99cc1e6]{border:1px solid #fff;padding:5px;border-radius:2px;margin-top:3px}.page-item[data-v-c99cc1e6]:hover{cursor:-webkit-grab}", ""]);
// Exports
module.exports = exports;
